import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import MarkedField from 'scoreboard/components/marked-field'
import selects from 'scoreboard/components/selects'
import MultiPrincipalChooser from 'scoreboard/components/multi-principal-chooser'
import fileAttachmentContent from 'scoreboard/components/files/file-attachment-content.hbs'

// Validators
import emailValidator from 'scoreboard/components/validators/email-validator'

import requiredValidator from 'scoreboard/components/validators/required-validator'
import template from './send-to-email-form.hbs'

var SendToEmail = Backbone.View.extend({

	className: 'send-to-email',

	tagName: 'form',

	initialize: function(options) {
		this.options = options || {}

		var EmailFormView = FormView.extend({
			test: this.test.bind(this)
		})

		this.formView = new EmailFormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this),
			guard: false
		})
	},

	render: function() {
		this.$el.empty().append(template(this.options))
		this._createEmailInput()
		this.markFields()
		this.formView.start()
		this.$('.file-attachment-content').append(fileAttachmentContent({
			detailIcon: 'docs-document',
			label: this.options.item,
			subLabel: this.options.section
		}))
		return this
	},

	_createEmailInput: function () {
		this.principalChooser = new MultiPrincipalChooser({
			el: this.$('.principal-chooser-container'),
			url: 'api/admin/users',
			placeholder: i18n.get('alerts.selectRecipients'),
			multiple: true,
			autofocus: true
		})
		// need to transform the labels right away, not in _prepareOptions
		this.principalChooser.draw = function(principals, options) {
			principals = _.map(principals, u => {
				return _.extend({}, u, {
					// #23286 escaping is done in superclass
					label: i18n.get('common.user.withEmail', u.label, u.email)
				})
			})
			principals = MultiPrincipalChooser.prototype.draw.call(this, principals, options)
			return principals
		}
		this.principalChooser.selectOptions = function(options) {
			let selectOptions = MultiPrincipalChooser.prototype.selectOptions.apply(this, arguments)
			return _.extend(selectOptions, {
				accessors: {
					value: 'email'
				},
				creatable: email => {
					var errorMsg = emailValidator(email)
					return {
						id: email,
						label: email,
						className: errorMsg ? 'is-invalid' : ''
					}
				},
				render: {
					create: function (d) {
						return i18n.get('common.add2', d.label)
					},
					errorMessage: function(d) {
						return i18n.get('common.error.email.tooltip')
					},
					option: function (d, searchTerm) {
						d.customIcon = 'user-avatar'
						return selects.optionHtml(d, searchTerm, {labelProperty: 'label'})
					},
					item: d => {
						d.customIcon = 'user-avatar'
						return selects.optionHtml(d)
					}
				}
			})
		}
		this.principalChooser.show({ open: false })
	},

	markFields: function() {
		this.recipientField = new MarkedField({
			el: this.$('[name=recipients]'),
			validators: [requiredValidator]
		}).render()
	},

	test: function() {
		if (!_.isEmpty(this.$('.items .is-invalid'))) {
			return i18n.get('common.error.email.tooltip')
		}
		return FormView.prototype.test.apply(this,arguments)
	},

	submit: function() {
		const {message} = formHelper.readFromDom(this.el)
		const data = {message, userIds: [], emails: []}
		this.principalChooser.selectedSet.forEach(immutableJsUserObj => {
			const id = immutableJsUserObj.get('id')
			if (id) {
				data.userIds.push(id)
			} else {
				data.emails.push(immutableJsUserObj.get('email'))
			}
		})
		this.trigger('done', data)
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.recipientField, this.principalChooser], 'remove')
	}
})

export default SendToEmail

SendToEmail.__filename__ = 'components/export/send-to-email-form.js'
